

const defaultState = {
    byIds: {
        ["ID"]: {
            loading: false,
            error: false,
            user: undefined,
            validationErrors: undefined,
        }
    },
    allIds: [],
    postInstallers: {},
    lastSuccessGetResult: []
} 

const installersReducer = (state = defaultState, action) => {
    switch(action.type) {
        case "GET_INSTALLERS_REQUEST": 
            return { ...state, loading: true }
        case "GET_INSTALLERS_SUCCESS":
            let { installers } = action.payload.data
            for (let installer of installers) {
                state.byIds[installer.id] = installer
                if (state.allIds.indexOf(installer.id) === -1) state.allIds.push(installer.id);
            }
            return { 
                ...state, 
                error: undefined, 
                loading: false, 
                allIds: [ ...state.allIds ], 
                byIds: { ...state.byIds },
                lastSuccessGetResult: [ ...action.payload.data.installers ], 
            }
        case "GET_INSTALLERS_FAILED":
            return { error: action.error, loading: false, allIds: [ ...state.allIds ], byIds: { ...state.byIds } }
        case "POST_INSTALLERS_REQUEST": 
            return { ...state, postInstallers: { loading: true } }
        case "POST_INSTALLERS_FAILED":
            return { ...state, postInstallers: { loading: false, error: action.error } }
        case "POST_INSTALLERS_SUCCESS":
            let installer = action.payload.data.installer;
            let { allIds, byIds } = state;
            if (state.allIds.indexOf(installer.id) === -1) state.allIds.push(installer.id);
            state.byIds[installer.id] = installer;
            return { 
                ...state, 
                byIds: { ...byIds }, 
                allIds: [ ...allIds ],
                postInstallers: { loading: false, data: action.payload }
            }
        default:
            return state;
    }
}

export default installersReducer;